import { render, staticRenderFns } from "./provider-eventpricepopover.vue?vue&type=template&id=356dd369&scoped=true"
import script from "./provider-eventpricepopover.vue?vue&type=script&lang=js"
export * from "./provider-eventpricepopover.vue?vue&type=script&lang=js"
import style0 from "./provider-eventpricepopover.vue?vue&type=style&index=0&id=356dd369&prod&scoped=true&lang=css"
import style1 from "./provider-eventpricepopover.vue?vue&type=style&index=1&id=356dd369&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356dd369",
  null
  
)

export default component.exports